export default __webpack_public_path__ + "static/media/at_1.937fc51b.svg";